/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_AsiaInputs */

const bn_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এশিয়া`)
};

const de_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asien`)
};

const el_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ασία`)
};

const en_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia`)
};

const es_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia`)
};

const fr_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asie`)
};

const hi_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एशिया`)
};

const hu_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ázsia`)
};

const id_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia`)
};

const it_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asia`)
};

const ja_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アジア`)
};

const ko_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아시아`)
};

const nl_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azië`)
};

const pl_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azja`)
};

const pt_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ásia`)
};

const ru_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Азия`)
};

const sv_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asien`)
};

const tr_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asya`)
};

const uk_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Азії`)
};

const vi_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Châu Á`)
};

const zh_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`亚洲`)
};

const zh_hant_region_asia = /** @type {(inputs: Region_AsiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`亞洲`)
};

/**
* | output |
* | --- |
* | "Asia" |
*
* @param {Region_AsiaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_asia = /** @type {((inputs?: Region_AsiaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_AsiaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_asia(inputs)
	if (locale === "de") return de_region_asia(inputs)
	if (locale === "el") return el_region_asia(inputs)
	if (locale === "en") return en_region_asia(inputs)
	if (locale === "es") return es_region_asia(inputs)
	if (locale === "fr") return fr_region_asia(inputs)
	if (locale === "hi") return hi_region_asia(inputs)
	if (locale === "hu") return hu_region_asia(inputs)
	if (locale === "id") return id_region_asia(inputs)
	if (locale === "it") return it_region_asia(inputs)
	if (locale === "ja") return ja_region_asia(inputs)
	if (locale === "ko") return ko_region_asia(inputs)
	if (locale === "nl") return nl_region_asia(inputs)
	if (locale === "pl") return pl_region_asia(inputs)
	if (locale === "pt") return pt_region_asia(inputs)
	if (locale === "ru") return ru_region_asia(inputs)
	if (locale === "sv") return sv_region_asia(inputs)
	if (locale === "tr") return tr_region_asia(inputs)
	if (locale === "uk") return uk_region_asia(inputs)
	if (locale === "vi") return vi_region_asia(inputs)
	if (locale === "zh") return zh_region_asia(inputs)
	return zh_hant_region_asia(inputs)
});